import { IInputNode, AssessmentNode } from '../../../actionCard'

export class MultiselectAssessmentNode
  extends AssessmentNode
  implements IInputNode<{ ids: number[]; text?: string } | undefined>
{
  public getValue(): { ids: number[]; text: string } | undefined {
    const assessmentValue = this.__getValue()
    if (!assessmentValue.ids.length) {
      return
    }
    return assessmentValue
  }

  public setValue(value?: { ids?: number[]; text?: string }): void {
    const oldValue = this.getValue()
    super.__setValue({ ids: value?.ids ?? [], text: value?.text ?? '' })
    const newValue = this.getValue()
    this.nodeSettings?.observer?.onValueSet?.(this, newValue, oldValue)
  }

  public getStringValue(): string {
    const value = this.getValue()
    return value ? JSON.stringify(value) : ''
  }

  public setStringValue(value?: string): void {
    if (!value) {
      this.setValue()
      return
    }
    const parsedValue = JSON.parse(value) as { ids: number[]; text?: string }
    this.setValue(parsedValue)
  }
}
